import { Flex } from '@chakra-ui/react';
import { FC } from 'react';
import PeOfferGridItem from './PeOfferGridItem';

interface Props {
  offers: PeOfferListItem[];
  onCardClick: (offer: PeOfferListItem) => void;
  onActionClick: (offer: PeOfferListItem) => void;
}

const PeOffersGrid: FC<Props> = ({ offers, onCardClick, onActionClick }) => {
  return (
    <Flex flexWrap="wrap" justifyContent="space-between" alignItems="stretch">
      {offers.map((offer, index) => (
        <PeOfferGridItem
          key={offer.id}
          offer={offer}
          onActionClick={() => onActionClick(offer)}
          onCardClick={() => onCardClick(offer)}
        />
      ))}
    </Flex>
  );
};

export default PeOffersGrid;
